import { createContext, useContext, useEffect, useRef, type ReactNode } from 'react'
import {
  NewEliteLandingAnalyticsScreen,
  trackNewEliteScreenLoaded,
  type NewEliteLandingAnalyticsScreenType
} from './newEliteLandingAnalytics'

const NewEliteLandingAnalyticsContext = createContext<NewEliteLandingAnalyticsScreenType | null>(null)

export function NewEliteLandingAnalyticsProvider({
  screen,
  children
}: {
  screen: NewEliteLandingAnalyticsScreenType
  children: ReactNode
}) {
  return (
    <NewEliteLandingAnalyticsContext.Provider value={screen}>{children}</NewEliteLandingAnalyticsContext.Provider>
  )
}

export function useNewEliteLandingAnalyticsScreen(): NewEliteLandingAnalyticsScreenType {
  const screen = useContext(NewEliteLandingAnalyticsContext)
  if (!screen) {
    return NewEliteLandingAnalyticsScreen.Landing
  }
  return screen
}

export function useTrackNewEliteLandingScreenLoadWhenReady(
  isReady: boolean,
  eliteLandingPageState?: string,
  extras?: Record<string, string | number | boolean | undefined>
) {
  const screen = useNewEliteLandingAnalyticsScreen()
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    if (!isReady || hasTrackedRef.current) {
      return
    }
    hasTrackedRef.current = true
    trackNewEliteScreenLoaded(screen, {
      eliteLandingPageState: eliteLandingPageState ?? '',
      ...extras
    })
  }, [isReady, screen, eliteLandingPageState, extras])
}
